import { render, staticRenderFns } from "./Identityoptions.vue?vue&type=template&id=a5a70e86"
import script from "./Identityoptions.vue?vue&type=script&lang=js"
export * from "./Identityoptions.vue?vue&type=script&lang=js"
import style0 from "./Identityoptions.vue?vue&type=style&index=0&id=a5a70e86&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports